export default "__VITE_ASSET__a3c80b62__"